import axios from '@/utils/axios';

 export const viewPDF = async (id) => {
  const response = await axios.get(`/sales-orders/${id}/pdf`,{
   responseType: 'blob' 
  });
  return response;
 };